import React from "react";
import SubHeading from "../SubHeading";

function StayConnected() {
  return (
    <>
      <div className="p-4 md:p-0 mb-6">
        <SubHeading text="stay connected" color="black" />

        {/* Social Media Links */}
        <div className="flex flex-col">
          {/* 1 */}
          <div className="w-full flex flex-row justify-between items-center font-bold text-xs mt-5">
            <div className="flex flex-row items-center">
              <div className="w-10 h-10 flex justify-center items-center bg-blue-600">
                <i class="text-lg text-white fab fa-facebook-f"></i>
              </div>
              <div className="pl-3">21, 800 Fans</div>
            </div>
            <div className="uppercase">Like</div>
          </div>

          {/* 2 */}
          <div className="w-full flex flex-row justify-between items-center font-bold text-xs mt-5">
            <div className="flex flex-row items-center">
              <div className="w-10 h-10 flex justify-center items-center bg-blue-500">
                <i class="text-lg text-white fab fa-twitter"></i>
              </div>
              <div className="pl-3">21, 800 Followers</div>
            </div>
            <div className="uppercase">Follow</div>
          </div>

          {/* 3 */}
          <div className="w-full flex flex-row justify-between items-center font-bold text-xs mt-5">
            <div className="flex flex-row items-center">
              <div className="w-10 h-10 flex justify-center items-center bg-red-600">
                <i class="text-lg text-white fab fab fa-youtube"></i>
              </div>
              <div className="pl-3">17,500 Subscribers</div>
            </div>
            <div className="uppercase">Subscribe</div>
          </div>
        </div>
      </div>
    </>
  );
}

export default StayConnected;
